import React from 'react';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';

import ComparisonBarChartHeader from './ComparisonBarChartHeader';
import ComparisonBarChartCategory from './ComparisonBarChartCategory';
import phrasesPropType from '../proptypes/phrases';
import carouselType from '../proptypes/carousel';
import { comparisonOptionType } from '../proptypes/comparison-options';

const ComparisonBarChart = ({
  data, layers, style, phrases, comparison, rotateComparison, carousel,
}) => (
  <>
    <ComparisonBarChartHeader
      key="header"
      data={data}
      layers={layers}
      style={style}
      comparison={comparison}
      rotateComparison={rotateComparison}
      carousel={carousel}
      phrases={phrases.carousel}
    />
    {map(data, category => (
      <ComparisonBarChartCategory
        key={category.key}
        data={category}
        layers={layers}
        style={style}
        phrases={phrases}
      />
    ))}
  </>
);

ComparisonBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  layers: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: stylePropType.isRequired,
  phrases: phrasesPropType.isRequired,
  comparison: comparisonOptionType.isRequired,
  rotateComparison: PropTypes.func.isRequired,
  carousel: carouselType.isRequired,
};

export default ComparisonBarChart;
